// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"CheckboxInput__Checkbox___3mjpm"};